module.exports = __webpack_public_path__ + "media/images/loghi/lbatv-title-21c75a5a6278947a74b15484afe15fff.png";